<template>
  <div>
    <div class="topbar" :style="'top:'+rectTop">
      <van-row>
        <van-col span="3"> <i class="iconfont iconback" @click="onBack" /> </van-col>
        <van-col span="18" class="topTitle">{{ pagetitle }}</van-col>
        <van-col span="3"><i v-if="right" :class="'iconfont '+ right+(isRightSelect?' mainColor':'')" @click="onRight" /> </van-col>
      </van-row>
    </div>
    <div class="emptyRect" />
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    // eslint-disable-next-line
    pagetitle: {
      default: 'DiveBoss'
    },
    // eslint-disable-next-line
    backUrl: {
      default: '/home/index'
    },
    // eslint-disable-next-line
    backLevel: {
      default: 1
    },
    // eslint-disable-next-line
    right: {
      default: undefined
    },
    // eslint-disable-next-line
    isRightSelect: {
      default: false
    },
    // 自行处理左边按钮事件
    // eslint-disable-next-line
    isLeftSelf:{
      default: false
    },
    // eslint-disable-next-line
    top: {
      default: '0px'
    },
    // eslint-disable-next-line
    topUnit:{
      default: 'em'
    }
  },
  data() {
    return {
      rectTop: '0px'
    }
  },
  watch: {
    top(newValue) {
      if (newValue > 0) {
        newValue = 0
      }
      this.rectTop = newValue + this.topUnit
      // console.log('设置位置', this.rectTop)
    }
  },
  created() {
    console.log('right', this.right)
  },
  methods: {
    onBack() {
      if (this.isLeftSelf) {
        this.$emit('leftClick')
        return
      }
      console.log('onBack', window.history.length)
      // this.$emit('leftClick')
      if (!this.backUrl) {
        this.$router.push('store/index')
      }
      window.history.length > this.backLevel
        ? this.$router.go(-this.backLevel)
        : this.$router.push(this.backUrl)
      // this.$router.replace(this.backUrl)
    },
    onRight() {
      this.$emit('rightClick')
    }
  }
}
</script>
<style scoped>
.topbar{
    height: 3em;
    line-height: 3em;
    color: #fff;
    background-color: #000;
    position:fixed;
    left: 0px;

    width: 100%;
    z-index: 101;
    /* border-bottom: 1px solid #f5f5f5; */
}
.topTitle{
      text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    /* font-weight: 700; */
}
.topbar .van-col{
    text-align: center;
}
.emptyRect{
  height: 3em;
}
</style>
